import { default as React } from 'react';
import { Table, DocsIcon } from '@backstage/core-components';

import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { useAccountFeatures } from '../hooks/useAccountFeatures';
import { CpeCardProps, DomainForwarder } from '../types';
import { DnsForwarderEditIcon } from './DNSForwarderEditIcon';
import { useStyles } from '../styles';

export function DnsForwarderCard(props: CpeCardProps) {
  const classes = useStyles();
  const features = useAccountFeatures();
  const { variant } = props;
  const [domainForwardingRules, setDomainForwardingRules] =
    React.useState<DomainForwarder>(features.dns_forwarder || { domains: [] });

  const handleDomainsUpdated = (updatedDomains: string[]) => {
    setDomainForwardingRules({
      ...features.dns_forwarder,
      domains: updatedDomains,
    });
  };

  const columns = [
    {
      title: 'Domains',
      field: 'domain',
    },
  ];

  let cardClass = '';
  let cardContentClass = '';
  if (variant === 'gridItem') {
    cardClass = classes.gridItemCard;
    cardContentClass = classes.gridItemCardContent;
  } else if (variant === 'fullHeight') {
    cardClass = classes.fullHeightCard;
    cardContentClass = classes.fullHeightCardContent;
  }

  return (
    <Card className={cardClass}>
      <CardHeader
        title="Internal DNS Resolution"
        action={
          <CardActions>
            <Tooltip title="Learn more about internal DNS resolution">
              <IconButton
                href="https://portal.developer.principal.com/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/infrastructure/aws/foundation-managed-vpc/#domain-forwarding"
                target="_blank"
              >
                <DocsIcon />
              </IconButton>
            </Tooltip>
            {domainForwardingRules.enabled && (
              <DnsForwarderEditIcon
                domainForwardingRules={domainForwardingRules}
                onDomainsUpdated={handleDomainsUpdated}
              />
            )}
          </CardActions>
        }
      />
      <Divider />
      {!domainForwardingRules.enabled ? (
        <CardContent>
          <Typography variant="h6">Coming Soon</Typography>
          <Typography variant="body1">
            Internal DNS resolution is not yet enabled for update. Please check
            back later.
          </Typography>
        </CardContent>
      ) : (
        <CardContent className={cardContentClass}>
          <Table
            columns={columns}
            data={domainForwardingRules.domains.map(domainName => ({
              domain: domainName,
            }))}
            options={{
              padding: 'dense',
              pageSize: 10,
              toolbar: false,
              paging: domainForwardingRules.domains.length > 10,
            }}
          />
        </CardContent>
      )}
    </Card>
  );
}
